@if (dialogName()) {
  <div class="kl-transaction__header">
    <span class="kl-transaction__title">{{ dialogName() }}</span>
  </div>
}
<ng-content></ng-content>
@if (loadError()) {
  <p class="text-danger mb-0">{{ 'error_data' | translate }}</p>
} @else if (loading() && clientRows().length === 0) {
  <!-- First load without designModule: grid not mounted yet for showLoading. -->
  <div class="kl-transaction__loading d-flex align-items-center justify-content-center p-2">
    <kl-loader />
  </div>
} @else {
  <kl-transaction-grid
    [columns]="columns()"
    [authNum]="authNum()"
    [rows]="clientRows()"
    [mapRows]="clientMapRows()"
    [actions]="actions()"
    [filterSelectItems]="filterSelectItems()"
    [gridHeaderName]="endpointName() || 'transactions'"
    [endpointName]="endpoint()"
    [designParentModule]="designParentModule()"
    [designModule]="designModule()"
    [designKey]="designKey()"
    [filterable]="filterable()"
    [customFilter]="customFilter() && showDetailFilter()"
    (customFilterEvent)="openDetailFilter($event)"
    (filterApplied)="onGridFilter($event)"
    (exportGrid)="onExport($event)"
    (refreshRequest)="reload()"
    [doExport]="doExport()"
    [doOther]="doOther()"
    [fullscreen]="fullscreen()"
    [deferResizing]="deferResizing()"
    [sortable]="sortable()"
    [allRowsPageSize]="allRowsPageSize()"
    [footerSumColumns]="footerSumColumns()" />
}
